export default {
  title: 'App móvil',
  fields: {
    name: 'Nombre de la app',
  },
  buttons: {
    save: 'Guardar',
  },
};
